import React from "react";
import "./Headings.css";

export default class Heading4 extends React.Component {
  public render() {
    return <h4 className="heading4">{this.props.children}</h4>;
  }
}
